import { render, staticRenderFns } from "./SettingRealname.vue?vue&type=template&id=659e0303&scoped=true"
import script from "./SettingRealname.vue?vue&type=script&lang=js"
export * from "./SettingRealname.vue?vue&type=script&lang=js"
import style0 from "./SettingRealname.vue?vue&type=style&index=0&id=659e0303&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e0303",
  null
  
)

export default component.exports